"use strict";

import apiClient from "../../utils/apiClient.js";
import { postWithFirebaseAuth } from "../../utils/firebaseApiClient.js";
import {
    GET_ALL_FACE_DIMENSIONS,
    GET_ALL_QUALITYASSURANCE_NOTES,
    GET_ALL_QUALITYASSURANCE_VERSIONS,
    GET_ALL_SPEECHES,
    GET_CHARACTERS_FOR_PROJECT,
    GET_LIP,
    GET_LIP_SYNC_STATUS,
    GET_SPEECH_FOR_PROJECT_BY_PAGE,
    GET_SPEECH_POSITION_AROUND_TIME,
    GET_SPEECHS_DETAILS_FOR_PROJECT,
    UPDATE_ONE_LIP,
    UPDATE_ONE_QUALITYASSURANCE_NOTE,
    UPDATE_ONE_SPEECH,
} from "../../ApiEndpoints.js";

export const getCharactersForProject = (payload, config) => (
    apiClient.post(GET_CHARACTERS_FOR_PROJECT, payload, config)
);

export const getSpeechForProjectByPage = (payload, config) => (
    apiClient.post(GET_SPEECH_FOR_PROJECT_BY_PAGE, payload, config)
);

export const getSpeechPositionAroundTime = (payload, config) => (
    apiClient.post(GET_SPEECH_POSITION_AROUND_TIME, payload, config)
);

export const getAllSpeeches = (payload, config) => (
    apiClient.post(GET_ALL_SPEECHES, payload, config)
);

export const updateOneSpeech = (payload, config) => (
    apiClient.post(UPDATE_ONE_SPEECH, payload, config)
);

export const getSpeechDetailsForProject = (payload, config) => (
    apiClient.post(GET_SPEECHS_DETAILS_FOR_PROJECT, payload, config)
);

export const getAllQualityAssuranceVersions = (payload, config) => (
    apiClient.post(GET_ALL_QUALITYASSURANCE_VERSIONS, payload, config)
);

export const getAllQualityAssuranceNotes = (payload, config) => (
    apiClient.post(GET_ALL_QUALITYASSURANCE_NOTES, payload, config)
);

export const updateOneQualityAssuranceNote = (payload, config) => (
    apiClient.post(UPDATE_ONE_QUALITYASSURANCE_NOTE, payload, config)
);

export const getAllFaceDimensions = (payload, config) => (
    apiClient.post(GET_ALL_FACE_DIMENSIONS, payload, config)
);

export const getLip = (payload, config) => apiClient.post(GET_LIP, payload, config);

export const getLipSyncStatus = (payload, config) => (
    postWithFirebaseAuth(GET_LIP_SYNC_STATUS, payload, config)
);

export const updateOneLip = (payload, config) => (
    apiClient.post(UPDATE_ONE_LIP, payload, config)
);
